import signImg from '../../assets/images/Login.jpg'
import logo from '../../assets/images/h_logo.png'
import React, { useState, useEffect } from "react";
import { API_STATUS } from '../../constants';
import { Formik, Field } from 'formik';
import * as Yup from 'yup';
import { useNavigate, useParams } from 'react-router-dom';
import { UserSignupApi } from '../../apis/login/user_signup';
import { useDispatch, useSelector } from 'react-redux';
import SetLoginToken from '../../utils/setlogintoken';
import { set_user_login } from '../../redux/VerifyLogin';
import { GetAuthToken } from '../../apis/gst/getAuthToken';
import { VerifyPanApi } from '../../apis/gst/verifyPanApi';
import { VerifyGstApi } from '../../apis/gst/verifyGstApi';
import { SignupOtpApi } from '../../apis/login/signup_otp_api';
import SignupOtp from './signup_otp';
import { VerifyUdataApi } from '../../apis/login/verify_udata_api';
import VerifyMobile from './components/verify_mobile';

export default function Signup() {

    const params = useParams({ mainCat: String, subCat: String });

    const dispatch = useDispatch();
    const authState = useSelector(state => state.checkuserlogin);
    const navigate = useNavigate();

    const [ApiStatus, setApiStatus] = useState(API_STATUS);

    const [errorMsg, setError] = useState('');

    const [GstTokenApi, setGstTokenApi] = useState(API_STATUS);
    const [GstApi, setGstApi] = useState(API_STATUS);
    const [PanApi, setPanApi] = useState(API_STATUS);
    const [genOtp, setGenOtp] = useState(API_STATUS);
    const [sendOtp, setSendOtp] = useState(API_STATUS);
    const [vdataApi, setVdataApi] = useState(API_STATUS);

    const [gstStatus, setGstStaus] = useState('Yes');
    const [gstToken, setGstToken] = useState('');
    const [panNo, setPanNo] = useState('');
    const [gstNo, setGstNo] = useState('');
    const [tradeName, setTradeName] = useState('');
    const [panData, setPanData] = useState('');
    const [gstData, setGstData] = useState('');
    const [panError, setPanError] = useState('');
    const [gstError, setGstError] = useState('');
    const [tnameError, setTnameError] = useState('');
    const [mobileError, setMobileError] = useState('');
    const [formBody, setBody] = useState('');
    const [panVerified, setPanv] = useState(false);
    const [mobile, setMobile] = useState('');
    const [vcode, setVcode] = useState('');
    const [maskedMobile, setMaskedMobile] = useState('');
    const [step, setStep] = useState(1);


    useEffect(() => {
        if (authState.isLogin) {
            navigate('/');
        }
    }, [authState]);




    useEffect(() => {
        if (!ApiStatus.isError && !ApiStatus.isLoader) {
            if (ApiStatus.data != null) {
                let res = ApiStatus.data;
                if (res['status'] === 1) {
                    let authBody = { "token": res.data['token'], "code": res.data['code'], "type": res.data['type'].toString() };
                    SetLoginToken(authBody);
                    dispatch(set_user_login(authBody));

                } else if (res['status'] === 2) {
                    setError(res['data']);
                }
            }
        }
        if (ApiStatus.isError) {
            setError("Network error");
        }
        if (ApiStatus.isLoader) {
            setError("");
        }

    }, [ApiStatus]);

    useEffect(() => {
        if (!vdataApi.isError && !vdataApi.isLoader) {
            if (vdataApi.data != null) {
                let res = vdataApi.data;
                if (res['status'] === 1) {
                    GetAuthToken(setGstTokenApi);
                } else if (res['status'] === 2) {
                    setError(res['data']);
                }
            }
        }
        if (vdataApi.isError) {
            setError("Network error");
        }
        if (vdataApi.isLoader) {
            setError("");
        }

    }, [vdataApi]);

    const phoneRegExp = /^[0-9\- ]{6,6}$/;

    const SignupSchema = Yup.object().shape({
        username: Yup.string()
            .min(4, 'Too Short!')
            .max(50, 'Too Long!')
            .required('Enter username'),
        password: Yup.string()
            .min(6, 'Too Short!')
            .required('Enter password'),
        first_name: Yup.string()
            .min(2, 'Too Short!')
            .max(50, 'Too Long!')
            .required('Enter first name'),
        // mobile: Yup.string()
        //     .matches(phoneRegExp, 'Enter valid mobile number')
        //     .required('Mobile number required'),
        last_name: Yup.string()
            .max(50, 'Too Long!')
            .required('Enter last name'),
        accType: Yup.string().required('Accept Terms & Privacy Policy'),
        email: Yup.string().email('Invalid email').required('Email id is required'),
        // gender: Yup.string().required('Select your gender'),
        // dob: Yup.string().required('Select your birthday'),
        artist: Yup.boolean(),
        // mobile: Yup.string().when('artist', {
        //     is: true,
        //     then: (schema) => schema.matches(phoneRegExp, 'Enter valid mobile number').required('Mobile number required')
        // }),
        dob: Yup.string().when('artist', {
            is: true,
            then: (schema) => schema.required('Select your birthday')
        }),
        gender: Yup.string().when('artist', {
            is: true,
            then: (schema) => schema.required('Select your gender')
        }),
        // company: Yup.string().when('artist', {
        //     is: false,
        //     then: (schema) => schema.required('Enter firm/company/agency')
        // }),
        state: Yup.string().when('artist', {
            is: false,
            then: (schema) => schema.required('Enter state name')
        }),
        city: Yup.string().when('artist', {
            is: false,
            then: (schema) => schema.required('Enter city name')
        }),
        pincode: Yup.string().when('artist', {
            is: false,
            then: (schema) => schema.required('Enter pincode')
        }),
        gstin: Yup.string().when('artist', {
            is: false,
            then: (schema) => schema.required('Enter GST number').min(15, 'Enter 15 digit GST number').max(15, 'Enter 15 digit GST number')
        }),
        pan: Yup.string().when('artist', {
            is: false,
            then: (schema) => schema.required('Enter PAN')
        }),
    });

    const verifygstpan = (body) => {
        if (params.mainCat === "User") {
            body.gstData = "";
            body.panData = "";
            UserSignupApi(body, setApiStatus);
        } else {
            setBody(body);
            VerifyUdataApi(body, setVdataApi);
            //  GetAuthToken(setGstTokenApi);
        }
    }

    const verifyMobile = () => {
        if (!panVerified) {
            setStep(2);
        } else {
            submitData();
        }
    }

    const submitData = () => {
        let body = formBody;
        body.mobile = maskedMobile.slice(0, 2) + mobile + maskedMobile.slice(-2);
        body.company = tradeName;

        body.panData = JSON.stringify(panData);
        body.gstData = JSON.stringify(gstData);
        UserSignupApi(body, setApiStatus);
    }

    const submitDataAlt = ({ mobile, uploadToken }) => {
        let body = formBody;
        body.mobile = mobile;
        body.uploadToken = uploadToken;
        body.company = tradeName;

        body.panData = JSON.stringify(panData);
        body.gstData = JSON.stringify(gstData);
        UserSignupApi(body, setApiStatus);
    }


    useEffect(() => {
        if (!GstTokenApi.isError && !GstTokenApi.isLoader) {
            if (GstTokenApi.data != null) {
                if (GstTokenApi.data.IsSuccess) {
                    setGstError('');
                    setTnameError('');
                    setPanError('');
                    // console.log(GstTokenApi.data.Data.Token);
                    setGstToken(GstTokenApi.data.Data.Token);
                    if (formBody.pan !== "" && formBody.pan !== panNo) {
                        setPanNo(formBody.pan);
                        VerifyPanApi(setPanApi, formBody.pan, GstTokenApi.data.Data.Token);
                    } else {
                        if (formBody.gstin !== "" && formBody.gstin !== gstNo) {
                            setGstNo(formBody.gstin);
                            VerifyGstApi(setGstApi, formBody.gstin, GstTokenApi.data.Data.Token);
                        } else {
                            verifyMobile();
                        }
                    }
                }
            }
        }
    }, [GstTokenApi]);

    useEffect(() => {
        if (panData !== '') {
            setTradeName(panData.fullname);
            // setMaskedMobile(panData.mobile);
            if (panData.mobile === null) {
                setPanError("Mobile number not linked to PAN");
            } else {
                setMaskedMobile(panData.mobile);
                if (formBody.gstin !== "" && formBody.gstin !== gstNo) {
                    setGstError('');
                    setTnameError('');
                    setGstNo(formBody.gstin);
                    VerifyGstApi(setGstApi, formBody.gstin, gstToken);
                } else {
                    verifyMobile();
                }
            }
        }
    }, [panData])

    useEffect(() => {
        if (PanApi.isError && !PanApi.isLoader) {
            setPanError("Enter valid pan details");
        }
        if (!PanApi.isError && !PanApi.isLoader) {
            // console.log(PanApi.data);
            if (PanApi.data != null) {
                if (PanApi.data.isSuccess) {
                    if (PanApi.data.data !== null) {
                        // console.log(PanApi.data.data);
                        setPanData(PanApi.data.data);
                    } else {
                        setPanError("Enter valid pan details");
                    }
                }
            }
        }
    }, [PanApi]);

    useEffect(() => {
        if (gstData !== '') {
            verifyMobile();
        }
    }, [gstData]);

    useEffect(() => {

        if (!GstApi.isError && !GstApi.isLoader) {
            //  console.log(GstApi.data);
            if (GstApi.data != null) {
                if (GstApi.data.isSuccess) {
                    if (GstApi.data.data.tradeNam !== null) {
                        setTradeName(GstApi.data.data.tradeNam);
                        setGstData(GstApi.data.data);
                    } else {
                        setGstError("Enter valid gst details");
                    }
                }
            }
        }
    }, [GstApi])

    const validateMobile = () => {
        if (mobile === "") {
            setMobileError("Enter mobile number");
        } else {
            if (!phoneRegExp.test(mobile)) {
                setMobileError("Enter valid mobile number");
            } else {
                const u_char = maskedMobile.slice(0, 2) + mobile + maskedMobile.slice(-2);
                const body = {
                    "mobile": u_char
                }
                SignupOtpApi(body, setGenOtp);
            }
        }
    }

    useEffect(() => {

        if (!genOtp.isError && !genOtp.isLoader) {
            //  console.log(GstApi.data);
            if (genOtp.data != null) {
                if (genOtp.data.status === 1) {
                    setStep(3);
                    setVcode(genOtp.data.vcode);
                } else {
                    setMobileError('This mobile number already exist');
                }
            }
        }
    }, [genOtp])

    const gstOnchange = (e) => {
        setGstNo(e.target.value.toUpperCase());
    }

    return <div>
        <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css" />

        <div className="container px-4 text-center">
            <div className="row justify-content-center pb-100 pt-100">
                <div className="col-md-3 d-none d-md-block">
                    <img src={signImg} alt='' width={450} />
                </div>
                <div className="col-md-6" style={{ position: 'relative' }}>
                    <Formik
                        initialValues={{
                            artist: params.mainCat === "User" ? true : false,
                            user_category: "",
                            first_name: "",
                            last_name: "",
                            email: "",
                            mobile: mobile,
                            gender: "",
                            dob: "",
                            category: params.mainCat,
                            company: tradeName,
                            gstin: "",
                            pan: "",
                            regcode: "",
                            country: "India",
                            state: "",
                            city: "",
                            pincode: "",
                            username: "",
                            password: "",
                            accType: "",
                            gst_status: 'Yes'
                        }}
                        validationSchema={SignupSchema}
                        onSubmit={values => {
                            let body = values;
                            setGstStaus(body.gst_status);

                            body.device = "Web";
                            body.ip = "";
                            body.devToken = "";
                            if (body.artist) {
                                body.type = 0;
                            } else {
                                body.type = 1;
                            }
                            if (body.dob == "") {
                                body.dob = "1947-01-01";
                            }
                            body.subCat = params.subCat.replaceAll("-", "/");

                            verifygstpan(body);

                            // UserSignupApi(body, setApiStatus);
                        }}
                    >
                        {({ values, errors, touched, isValid, handleChange, setFieldTouched, setFieldValue, handleSubmit }) => (
                            <div className="card bg-white shadow py-3">
                                <div className="card-body">
                                    <div className="row justify-content-center" style={{ paddingBottom: 40 }}>
                                        <img src={logo} alt='' style={{ width: 275 }} /><br />
                                        {
                                            step === 1 &&
                                            <div>
                                                <h4 style={{ fontSize: 24, paddingTop: 20 }}>Complete Signup</h4>
                                                <div style={{ color: "#727272", fontSize: 18, paddingTop: 7 }}>{params.mainCat + ' > ' + params.subCat.replaceAll("-", "/")}</div>
                                            </div>
                                        }
                                        {
                                            (step === 2 || step === 3) &&
                                            <div>
                                                <h4 style={{ fontSize: 24, paddingTop: 20 }}>Verify Mobile Number</h4>
                                                <div style={{ color: "#727272", fontSize: 18, paddingTop: 7 }}>Welcome</div>
                                                <h4 style={{ fontSize: 16, paddingTop: 5 }}>{tradeName}</h4>
                                            </div>
                                        }

                                    </div>
                                    {
                                        errorMsg !== "" &&

                                        <div className='alert alert-danger' style={{ textAlign: 'left' }}>
                                            <strong>Failed !!</strong><br />
                                            {errorMsg}
                                        </div>
                                    }

                                    {
                                        step === 1 &&
                                        <div>

                                            <div className="col-lg-12 col-md-12 col-sm-12 col-12 mb-3">
                                                {
                                                    values.user_category !== "" &&
                                                    <div style={{ textAlign: 'left', paddingLeft: 3 }}>{'Sub category in ' + params.subCat.replaceAll("-", "/")}</div>
                                                }
                                                <div className="contact-field">
                                                    <Field className="form-control" type="text" name="user_category" placeholder={'Sub category in ' + params.subCat.replaceAll("-", "/")} />
                                                </div>
                                                {
                                                    errors.user_category && touched.user_category &&
                                                    <div className='text-danger' style={{ textAlign: 'left' }}>{errors.user_category}</div>
                                                }
                                            </div>

                                            <div className="col-lg-12 col-md-12 col-sm-12 col-12 mb-3">
                                                {
                                                    values.first_name !== "" &&
                                                    <div style={{ textAlign: 'left', paddingLeft: 3 }}>First Name</div>
                                                }
                                                <div className="contact-field">
                                                    <Field className="form-control" type="text" name="first_name" placeholder="First Name *" />
                                                </div>
                                                {
                                                    errors.first_name && touched.first_name &&
                                                    <div className='text-danger' style={{ textAlign: 'left' }}>{errors.first_name}</div>
                                                }
                                            </div>

                                            <div className="col-lg-12 col-md-12 col-sm-12 col-12 mb-3">
                                                {
                                                    values.last_name !== "" &&
                                                    <div style={{ textAlign: 'left', paddingLeft: 3 }}>Last Name</div>
                                                }
                                                <div className="contact-field">
                                                    <Field className="form-control" type="text" name="last_name" placeholder="Last Name *" />
                                                </div>
                                                {
                                                    errors.last_name && touched.last_name &&
                                                    <div className='text-danger' style={{ textAlign: 'left' }}>{errors.last_name}</div>
                                                }
                                            </div>

                                            {
                                                values.category === "User" &&

                                                <div className="col-lg-12 col-md-12 col-sm-12 col-12 mb-3">
                                                    {
                                                        values.mobile !== "" &&
                                                        <div style={{ textAlign: 'left', paddingLeft: 3 }}>Mobile Number</div>
                                                    }
                                                    <div className="contact-field">
                                                        <Field className="form-control" type="text" name="mobile" placeholder="Mobile Number *" />
                                                    </div>
                                                    {
                                                        errors.mobile && touched.mobile &&
                                                        <div className='text-danger' style={{ textAlign: 'left' }}>{errors.mobile}</div>
                                                    }
                                                </div>
                                            }

                                            <div className="col-lg-12 col-md-12 col-sm-12 col-12 mb-3">
                                                {
                                                    values.username !== "" &&
                                                    <div style={{ textAlign: 'left', paddingLeft: 3 }}>Username</div>
                                                }
                                                <div className="contact-field">
                                                    <Field className="form-control" type="text" name="username" placeholder="Username *" />
                                                </div>
                                                {
                                                    errors.username && touched.username &&
                                                    <div className='text-danger' style={{ textAlign: 'left' }}>{errors.username}</div>
                                                }
                                            </div>

                                            <div className="col-lg-12 col-md-12 col-sm-12 col-12 mb-3">
                                                {
                                                    values.password !== "" &&
                                                    <div style={{ textAlign: 'left', paddingLeft: 3 }}>Password</div>
                                                }
                                                <div className="contact-field">
                                                    <Field className="form-control" type="text" name="password" placeholder="Password *" />
                                                </div>
                                                {
                                                    errors.password && touched.password &&
                                                    <div className='text-danger' style={{ textAlign: 'left' }}>{errors.password}</div>
                                                }
                                            </div>

                                            <div className="col-lg-12 col-md-12 col-sm-12 col-12 mb-3">
                                                {
                                                    values.email !== "" &&
                                                    <div style={{ textAlign: 'left', paddingLeft: 3 }}>Email id</div>
                                                }
                                                <div className="contact-field">
                                                    <Field className="form-control" type="email" name="email" placeholder="Email id *" />
                                                </div>
                                                {
                                                    errors.email && touched.email &&
                                                    <div className='text-danger' style={{ textAlign: 'left' }}>{errors.email}</div>
                                                }
                                            </div>
                                            {
                                                values.category !== "User" &&

                                                <div>

                                                    {/* <div className="col-lg-12 col-md-12 col-sm-12 col-12 mb-3" style={{ textAlign: 'left' }}>
                                                <div style={{ textAlign: 'left', paddingLeft: 3 }}>Have GST No.</div>
                                                <div className="form-check form-check-inline">
                                                    <input
                                                        onClick={() => {
                                                            setFieldValue('gst_status', 'Yes');
                                                        }}
                                                        className="form-check-input" type="radio" id="gst_yes" name='gst_status' defaultChecked />
                                                    <label
                                                        onClick={() => {
                                                            setFieldValue('gst_status', 'Yes');
                                                        }}
                                                        class="form-check-label" for="gst_yes">
                                                        Yes
                                                    </label>
                                                </div>
                                                <div className="form-check form-check-inline">
                                                    <input
                                                        onClick={() => {
                                                            setFieldValue('gst_status', 'No');
                                                        }}
                                                        className="form-check-input" type="radio" id="gst_no" name='gst_status' />
                                                    <label
                                                        onClick={() => {
                                                            setFieldValue('gst_status', 'No');
                                                        }}
                                                        class="form-check-label" for="gst_no">
                                                        No
                                                    </label>
                                                </div>

                                            </div> */}
                                                    {
                                                        values.gst_status === 'Yes' &&
                                                        <div>
                                                            {/* <div className="col-lg-12 col-md-12 col-sm-12 col-12 mb-3">
                                                                {
                                                                    values.regcode !== "" &&
                                                                    <div style={{ textAlign: 'left', paddingLeft: 3 }}>CIF No.</div>
                                                                }
                                                                <div className="contact-field">
                                                                    <Field className="form-control" type="text" name="regcode" placeholder="CIF No." />
                                                                </div>
                                                                {
                                                                    errors.regcode && touched.regcode &&
                                                                    <div className='text-danger' style={{ textAlign: 'left' }}>{errors.password}</div>
                                                                }
                                                            </div> */}

                                                            <div className="col-lg-12 col-md-12 col-sm-12 col-12 mb-3">
                                                                {
                                                                    values.gstin !== "" &&
                                                                    <div style={{ textAlign: 'left', paddingLeft: 3 }}>GST No. *</div>
                                                                }
                                                                <div className="contact-field">
                                                                    <Field className="form-control" value={values.gstin} onChange={(e) => {
                                                                        setFieldValue('gstin', e.target.value.toUpperCase());
                                                                        const gn = e.target.value.toUpperCase();
                                                                        if (gn.length > 12) {
                                                                            const pn = gn.slice(2, 12);
                                                                            setFieldValue('pan', pn);
                                                                        } else {
                                                                            setFieldValue('pan', '');
                                                                        }
                                                                    }} type="text" name="gstin" placeholder="GST No. *" />
                                                                </div>
                                                                {
                                                                    errors.gstin && touched.gstin &&
                                                                    <div className='text-danger' style={{ textAlign: 'left' }}>{errors.gstin}</div>
                                                                }

                                                                {
                                                                    gstError !== "" && <div className='text-danger' style={{ textAlign: 'left' }}>{gstError}</div>
                                                                }
                                                            </div>
                                                        </div>
                                                    }

                                                    <div className="col-lg-12 col-md-12 col-sm-12 col-12 mb-3">
                                                        {
                                                            values.pan !== "" &&
                                                            <div style={{ textAlign: 'left', paddingLeft: 3 }}>PAN *</div>
                                                        }
                                                        <div className="contact-field">
                                                            <Field className="form-control" type="text" name="pan" placeholder="PAN *" readOnly />
                                                        </div>
                                                        {
                                                            errors.pan && touched.pan &&
                                                            <div className='text-danger' style={{ textAlign: 'left' }}>{errors.pan}</div>
                                                        }

                                                        {
                                                            panError !== "" &&
                                                            <div className='text-danger' style={{ textAlign: 'left' }}>{panError}</div>
                                                        }
                                                    </div>

                                                    <div className="col-lg-12 col-md-12 col-sm-12 col-12 mb-3">
                                                        {
                                                            values.state !== "" &&
                                                            <div style={{ textAlign: 'left', paddingLeft: 3 }}>State</div>
                                                        }
                                                        <div className="contact-field">
                                                            <Field className="form-control" type="text" name="state" placeholder="State *" />
                                                        </div>
                                                        {
                                                            errors.state && touched.state &&
                                                            <div className='text-danger' style={{ textAlign: 'left' }}>{errors.state}</div>
                                                        }
                                                    </div>

                                                    <div className="col-lg-12 col-md-12 col-sm-12 col-12 mb-3">
                                                        {
                                                            values.city !== "" &&
                                                            <div style={{ textAlign: 'left', paddingLeft: 3 }}>City</div>
                                                        }
                                                        <div className="contact-field">
                                                            <Field className="form-control" type="text" name="city" placeholder="City *" />
                                                        </div>
                                                        {
                                                            errors.city && touched.city &&
                                                            <div className='text-danger' style={{ textAlign: 'left' }}>{errors.city}</div>
                                                        }
                                                    </div>

                                                    <div className="col-lg-12 col-md-12 col-sm-12 col-12 mb-3">
                                                        {
                                                            values.pincode !== "" &&
                                                            <div style={{ textAlign: 'left', paddingLeft: 3 }}>Pincode</div>
                                                        }
                                                        <div className="contact-field">
                                                            <Field className="form-control" type="text" name="pincode" placeholder="Pincode *" />
                                                        </div>
                                                        {
                                                            errors.pincode && touched.pincode &&
                                                            <div className='text-danger' style={{ textAlign: 'left' }}>{errors.pincode}</div>
                                                        }
                                                    </div>


                                                </div>
                                            }

                                            {
                                                values.category === "User" &&


                                                <div>

                                                    <div className="col-lg-12 col-md-12 col-sm-12 col-12 mb-3">
                                                        <div style={{ textAlign: 'left', paddingLeft: 3 }}>Birthday</div>
                                                        <div className="contact-field">
                                                            <Field className="form-control" type="date" name="dob" placeholder="Birthday" />
                                                        </div>
                                                        {
                                                            errors.dob && touched.dob &&
                                                            <div className='text-danger' style={{ textAlign: 'left' }}>{errors.dob}</div>
                                                        }
                                                    </div>

                                                    <div className="col-lg-12 col-md-12 col-sm-12 col-12 mb-3">
                                                        <div style={{ textAlign: 'left', paddingLeft: 3 }}>Select  Gender</div>
                                                        <div className="contact-field" style={{ textAlign: 'left' }}>
                                                            <Field className="btn-check" type="radio" id="gender-male" name="gender" value="Male" autocomplete="off" />
                                                            <label class="btn btn-outline-success" for="gender-male">Male</label> &nbsp; &nbsp;

                                                            <Field className="btn-check" type="radio" id="gender-female" name="gender" value="Female" autocomplete="off" />
                                                            <label class="btn btn-outline-success" for="gender-female">Female</label>&nbsp; &nbsp;

                                                            <Field className="btn-check" type="radio" id="gender-other" name="gender" value="Other" autocomplete="off" />
                                                            <label class="btn btn-outline-success" for="gender-other">Other</label>
                                                        </div>

                                                    </div>

                                                    <div className="col-lg-12 col-md-12 col-sm-12 col-12 mb-3">
                                                        <div className="form-check" style={{ textAlign: 'left', alignContent: 'center' }}>
                                                            <input
                                                                onClick={() => {
                                                                    setFieldValue('accType', 'Self');
                                                                }}
                                                                className="form-check-input" type="radio" value="Self" id="agree_1" name='accType' />
                                                            <label
                                                                onClick={() => {
                                                                    setFieldValue('accType', 'Self');
                                                                }}
                                                                class="form-check-label" for="agree_1">
                                                                I am 18 or above and agree to the <a href='https://filmwings.com/index.php/terms_service' className='text-primary'>Terms, </a><a href='https://filmwings.com/index.php/privacy_policy' className='text-primary'> Privacy Policy</a>
                                                            </label>
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-12 col-md-12 col-sm-12 col-12 mb-3">
                                                        <div className="form-check" style={{ textAlign: 'left', alignContent: 'center' }}>
                                                            <input
                                                                onClick={() => {
                                                                    setFieldValue('accType', 'Parent');
                                                                }}
                                                                className="form-check-input" type="radio" value="Parent" id="agree_2" name='accType' />
                                                            <label
                                                                onClick={() => {
                                                                    setFieldValue('accType', 'Parent');
                                                                }}
                                                                class="form-check-label" for="agree_2">
                                                                I am a parent creating an account for my who is below 18, I only will be operating this account, I agree to the <a href='https://filmwings.com/index.php/terms_service' className='text-primary'>Terms, </a><a href='https://filmwings.com/index.php/privacy_policy' className='text-primary'> Privacy Policy</a>
                                                            </label>
                                                        </div>
                                                    </div>

                                                </div>
                                            }

                                            {
                                                values.category !== "User" &&

                                                <div className="col-lg-12 col-md-12 col-sm-12 col-12 mb-3">
                                                    <div className="form-check" style={{ textAlign: 'left', alignContent: 'center' }}>
                                                        <input
                                                            onClick={() => {
                                                                setFieldValue('accType', 'Self');
                                                            }}
                                                            className="form-check-input" type="radio" value="Self" id="agree_1" name='accType' />
                                                        <label
                                                            onClick={() => {
                                                                setFieldValue('accType', 'Self');
                                                            }}
                                                            class="form-check-label" for="agree_1">
                                                            I agree to the <a href='https://filmwings.com/index.php/terms_service' className='text-primary'>Terms, </a><a href='https://filmwings.com/index.php/privacy_policy' className='text-primary'> Privacy Policy</a>
                                                        </label>
                                                    </div>
                                                </div>

                                            }


                                            {
                                                errors.accType && touched.accType &&
                                                <div className='text-danger' style={{ textAlign: 'left' }}>{errors.accType}</div>
                                            }

                                            {
                                                errorMsg !== "" &&

                                                <div className='alert text-danger' style={{ textAlign: 'left' }}>
                                                    <strong>Failed !!</strong><br />
                                                    {errorMsg}
                                                </div>
                                            }

                                            <div className="row mt-3">
                                                <div className='col-6' style={{ textAlign: 'left', paddingLeft: 50 }}>
                                                    <a href={params.mainCat =='User' ? '/select_cat/user' : '/select_cat/client'} className='btn btn-outline-danger'>Back</a>
                                                </div>
                                                <div className="col-6" style={{ textAlign: 'right', paddingRight: 50 }}>
                                                    {
                                                        (ApiStatus.isLoader || GstApi.isLoader || GstTokenApi.isLoader || PanApi.isLoader || vdataApi.isLoader) &&
                                                        <div className="spinner-border text-primary" role="status">
                                                        </div>
                                                    }
                                                    {
                                                        !ApiStatus.isLoader && !GstApi.isLoader && !GstTokenApi.isLoader && !PanApi.isLoader && !vdataApi.isLoader &&
                                                        <button
                                                            onClick={() => {
                                                                if (!isValid) {
                                                                    setFieldTouched('first_name');
                                                                    setFieldTouched('last_name');
                                                                    setFieldTouched('dob');
                                                                    setFieldTouched('email');
                                                                    setFieldTouched('gender');
                                                                    setFieldTouched('gstin');
                                                                    setFieldTouched('regcode');
                                                                    setFieldTouched('pan');
                                                                    setFieldTouched('state');
                                                                    setFieldTouched('city');
                                                                    setFieldTouched('pincode');
                                                                    setFieldTouched('accType');
                                                                    setFieldTouched('username');
                                                                    setFieldTouched('password');
                                                                } else {
                                                                    handleSubmit();
                                                                }
                                                            }}
                                                            type="button" className="button_slide slide_right orange">Signup</button>

                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    }

                                    {
                                        step === 2 &&
                                        <div>
                                            <VerifyMobile
                                                genOtp={genOtp}
                                                setMobileError={setMobileError}
                                                mobileError={mobileError}
                                                setMobile={setMobile}
                                                maskedMobile={maskedMobile}
                                                setStep={setStep}
                                                submitDataAlt={submitDataAlt}
                                            />
                                        </div>
                                    }
                                    {
                                        step === 3 &&
                                        <div>
                                            <SignupOtp submitData={submitData} setStep={setStep} mobile={maskedMobile} setPanV={setPanv} vcode={vcode} />
                                        </div>
                                    }

                                </div>



                            </div>
                        )}
                    </Formik>
                    {
                        panVerified && ApiStatus.isLoader &&

                        <div role="status" style={{ position: 'absolute', top: 0, right: 0, bottom: 0, left: 0, backgroundColor: '#ffffffb8', padding: 30, paddingTop: 200 }}>
                            <p className='text-green-600'>PAN Verified</p>
                            <p>Signup Processing...</p>
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
}